import { v7 as uuidv7 } from 'uuid'

/**
 * Generate a UUID v7 string. Time-ordered and globally unique.
 */
export const generateUuid = (): string => uuidv7()
